export default __webpack_public_path__ + "static/lion-f5e59ecdb42bb62fcaceaf69c47f7577.png";